(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["em"] && !Shopify.designMode) return;
  try {
    /*
    On desktop, when 'Thumbnails' is picked as the desktop slideshow controls style, the product
    media gallery in grid presentation shows the slideshow's thumbnail rail next to the
    natural-flow image grid (see media.css). Those thumbnails are wired by the theme to drive the
    hidden slideshow, so on desktop we intercept them: a click scrolls the page to the matching
    grid image, and an IntersectionObserver keeps `aria-selected` on the thumbnail whose image
    crosses the middle of the viewport. On mobile the slideshow is the visible presentation and
    the thumbnails keep their stock behavior.
  */
  (() => {
    const desktop = window.matchMedia('(min-width: 750px)');

    const init = () => {
      for (const gallery of document.querySelectorAll(
        '.product-information__media media-gallery.media-gallery--grid'
      )) {
        const thumbs = gallery.querySelectorAll(
          'slideshow-controls[thumbnails]:not(.media-gallery__mobile-controls) .slideshow-controls__thumbnail'
        );
        const items = gallery.querySelectorAll('.media-gallery__grid > *');
        if (!thumbs.length || !items.length) continue;

        const select = (index) => {
          thumbs.forEach((thumb, i) => {
            if (i === index) {
              thumb.setAttribute('aria-selected', 'true');
            } else {
              thumb.removeAttribute('aria-selected');
            }
          });
        };

        thumbs.forEach((thumb, i) => {
          thumb.addEventListener(
            'click',
            (event) => {
              if (!desktop.matches) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              items[i]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            },
            true
          );
        });

        const itemList = [...items];
        const inBand = new Set();
        const observer = new IntersectionObserver(
          (entries) => {
            if (!desktop.matches) return;
            for (const entry of entries) {
              if (entry.isIntersecting) {
                inBand.add(entry.target);
              } else {
                inBand.delete(entry.target);
              }
            }
            const current = itemList.findIndex((item) => inBand.has(item));
            if (current > -1) select(current);
          },
          { rootMargin: '-45% 0px -45% 0px' }
        );
        itemList.forEach((item) => observer.observe(item));
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grid"] && !Shopify.designMode) return;
  try {
    (() => {
    const PLACEHOLDER_FIGURES =
      "#MainContent[data-template='collection'] .shopify-section:has(> collection-component) ~ .section-wrapper > .section:not(:has(.image-block))";
    const UNPOSITIONED_BASELINE_REGIONS = [
      'product-recommendations .section-resource-list__content',
      '.section-resource-list__header',
      `.section-content-wrapper:not(:has(.image-block)):where(:not(${PLACEHOLDER_FIGURES} *))`,
      '.facets-toggle',
      '.facets-block-wrapper--horizontal',
      '.facets--horizontal.facets-controls-wrapper',
    ];
    const UNPOSITIONED_REGIONS = ['#MainContent', 'footer', ...UNPOSITIONED_BASELINE_REGIONS];
    const CONTAINED_REGIONS = ['#header-component'];
    const STICKY_REGIONS = ['.product-details'];
    const REGIONS = [...UNPOSITIONED_REGIONS, ...CONTAINED_REGIONS, ...STICKY_REGIONS];
    const COLUMN_BASELINE_REGIONS = ['#header-component', 'footer'];
    const FULL_WIDTH_BASELINE_REGIONS = ['.product-details', ...UNPOSITIONED_BASELINE_REGIONS];
    const BASELINE_REGIONS = [...COLUMN_BASELINE_REGIONS, ...FULL_WIDTH_BASELINE_REGIONS];
    const PADDING_BASELINE_REGIONS = ['.product-information', `${PLACEHOLDER_FIGURES} .section-content-wrapper`];
    const IMAGE_BAND_REGIONS = [
      ['.product-card', '.card-gallery'],
      ['.group-block-content:has(> .image-block:first-child)', '.image-block'],
      ['.section-content-wrapper:has(> .image-block:first-child)', '.image-block'],
      ['#search-modal .predictive-search-results__list', '.resource-card__media'],
    ];
    const IMAGE_BAND_SELECTORS = IMAGE_BAND_REGIONS.map(([region]) => region);
    const SPAN_REGIONS = [
      ['.menu-drawer', '.menu-drawer__navigation'],
      ['#search-modal .predictive-search', '.predictive-search-results__title'],
    ];
    const MARGIN_LINE_REGIONS = ['#search-modal .search-modal__content'];
    const SPAN_SELECTORS = SPAN_REGIONS.map(([region]) => region);
    const SPIRAL_TEMPLATES = ['product', 'collection'];
    const MIRRORED_SPIRAL_TEMPLATES = ['collection'];
    const COLUMNS = 8;
    const MOBILE_COLUMNS = 2;
    const MOBILE = 'screen and (max-width: 749px)';
    const DESKTOP = 'screen and (min-width: 750px)';
    const HALF_UNIT_REGIONS = [
      ['#header-component', MOBILE],
      ['#search-modal .predictive-search'],
      ['#search-modal .predictive-search-results__list'],
    ];
    const SCROLL_HOLD = 1000;
    const MODES = ['scroll', 'on', 'off'];
    const TOUCH = '(pointer: coarse)';
    const LEADING = 21;
    const HUE = '79 153 255';
    const TOP_LINE = '--grid-guides-top-line-color';
    const IMAGE_RATIO = '--grid-guides-image-ratio';
    const SPAN_HEIGHT = '--grid-guides-span-height';
    const COLUMNS_IMAGE = '--grid-guides-columns-image';
    const HALF_COLOR = '--grid-guides-half-baseline-color';

    const INSET = 'var(--grid-guides-inset)';
    const TRACK = `(100% - ${INSET} * 2 + var(--grid-guides-gutter))`;

    const band = (expression) => [`calc(${expression} - 0.5px)`, `calc(${expression} + 0.5px)`];

    const hairline = ([start, end], color = 'var(--grid-guides-color)') =>
      `transparent ${start}, ${color} ${start}, ${color} ${end}, transparent ${end}`;

    const columnGradient = (columns) => {
      const lines = [band(INSET)];

      for (let column = 1; column < columns; column += 1) {
        lines.push(band(`${INSET} + ${TRACK} * ${column} / ${columns} - var(--grid-guides-gutter)`));
        lines.push(band(`${INSET} + ${TRACK} * ${column} / ${columns}`));
      }

      lines.push(band(`100% - ${INSET}`));

      return `linear-gradient(
      to right,
      ${lines.map((line) => hairline(line)).join(',\n    ')}
    )`;
    };

    const tickGradient = (color) => `linear-gradient(
      to bottom,
      ${color} 0 0.5px,
      transparent 0.5px calc(100% - 0.5px),
      ${color} calc(100% - 0.5px) 100%
    )`;

    const bottomLineGradient = `linear-gradient(to bottom, ${hairline(band('100%'), 'var(--grid-guides-edge-color)')})`;

    const topLineGradient = `linear-gradient(to bottom, ${hairline(band('0%'), `var(${TOP_LINE})`)})`;

    const selectorList = (regions, suffix = '') => regions.map((region) => region + suffix).join(',\n');

    const COLUMNS_LAYER = { image: `var(${COLUMNS_IMAGE})`, origin: 'border-box' };
    const TOP_LINE_LAYER = { image: topLineGradient, origin: 'content-box' };
    const BOTTOM_LINE_LAYER = { image: bottomLineGradient, origin: 'content-box' };
    const ticksLayer = (color, unit) => ({
      image: tickGradient(color),
      size: `100% ${unit}`,
      repeat: 'repeat-y',
      origin: 'content-box',
      clip: 'content-box',
    });
    const TICKS_LAYER = ticksLayer('var(--grid-guides-baseline-color)', 'var(--grid-guides-baseline)');
    const HALF_TICKS_LAYER = ticksLayer(`var(${HALF_COLOR})`, 'calc(var(--grid-guides-baseline) / 2)');

    const guideLayers = (...layers) => {
      const column = (property, fallback) => layers.map((layer) => layer[property] ?? fallback).join(', ');

      return `background-image: ${column('image')};
    background-position: bottom;
    background-size: ${column('size', 'auto')};
    background-repeat: ${column('repeat', 'no-repeat')};
    background-origin: ${column('origin', 'border-box')};
    background-clip: ${column('clip', 'border-box')};`;
    };

    const OVERLAY = `content: '';
    position: absolute;
    inset: 0;
    z-index: calc(var(--layer-overlay) - 1);
    pointer-events: none;`;

    const COLUMN_BASELINE_LAYERS = guideLayers(
      COLUMNS_LAYER,
      TOP_LINE_LAYER,
      BOTTOM_LINE_LAYER,
      TICKS_LAYER,
      HALF_TICKS_LAYER,
    );
    const BASELINE_LAYERS = guideLayers(TOP_LINE_LAYER, BOTTOM_LINE_LAYER, TICKS_LAYER, HALF_TICKS_LAYER);

    const halfUnitRule = (selector) => `${selector} {
    ${HALF_COLOR}: rgb(${HUE} / 0.0625);
  }`;

    const HALF_UNIT_RULES = HALF_UNIT_REGIONS.map(([selector, media]) =>
      media ? `@media ${media} {\n${halfUnitRule(selector).replace(/^/gm, '  ')}\n}` : halfUnitRule(selector),
    ).join('\n\n');

    const spiralPath =
      'M 0 0 A 5 5 0 0 0 5 5 A 3 3 0 0 0 8 2 A 2 2 0 0 0 6 0 A 1 1 0 0 0 5 1 A 1 1 0 0 0 6 2';
    const spiralSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 5" fill="none"><path d="${spiralPath}" stroke="rgb(${HUE} / 0.25)" stroke-width="1" vector-effect="non-scaling-stroke"/></svg>`;

    const spiralCutGradient = `linear-gradient(to right, ${hairline(band('75%'), 'var(--grid-guides-edge-color)')})`;

    const marginLinesGradient = `linear-gradient(to right, ${hairline(band('0%'))}, ${hairline(band('100%'))})`;

    const STYLES = `
  :root {
    --grid-guides-baseline: var(--leading, ${LEADING}px);
    --grid-guides-gutter: calc(var(--grid-guides-baseline) * 2);
    --grid-guides-inset: calc(var(--grid-guides-baseline) * 2);
    --grid-guides-color: rgb(${HUE} / 0.375);
    --grid-guides-baseline-color: rgb(${HUE} / 0.125);
    ${HALF_COLOR}: transparent;
    --grid-guides-edge-color: rgb(${HUE} / 0.25);
    --grid-guides-warning-color: rgb(255 0 0 / 0.625);
    ${TOP_LINE}: transparent;
    ${COLUMNS_IMAGE}: ${columnGradient(COLUMNS)};
  }

  @media ${MOBILE} {
    :root {
      --grid-guides-gutter: var(--grid-guides-baseline);
      --grid-guides-inset: calc(var(--grid-guides-baseline) * 0.75);
      ${COLUMNS_IMAGE}: ${columnGradient(MOBILE_COLUMNS)};
    }
  }

  ${selectorList([...UNPOSITIONED_REGIONS, ...IMAGE_BAND_SELECTORS, ...PADDING_BASELINE_REGIONS])},
  ${selectorList(STICKY_REGIONS, ':not(.sticky-content--desktop)')} {
    position: relative;
  }

  @media ${MOBILE} {
    ${selectorList(STICKY_REGIONS)} {
      position: relative;
    }
  }

  ${selectorList(REGIONS, '::after')} {
    ${OVERLAY}
    background-repeat: no-repeat;
    background-image: var(${COLUMNS_IMAGE});
  }

  ${selectorList(COLUMN_BASELINE_REGIONS, '::after')} {
    padding-inline: ${INSET};
    ${COLUMN_BASELINE_LAYERS}
  }

  ${HALF_UNIT_RULES}

  ${selectorList(FULL_WIDTH_BASELINE_REGIONS, '::after')} {
    ${BASELINE_LAYERS}
  }

  ${selectorList(PADDING_BASELINE_REGIONS, '::after')} {
    ${OVERLAY}
    top: auto;
    height: var(--padding-block-end);
    ${BASELINE_LAYERS}
  }

  .product-information::after {
    padding-inline: ${INSET};
  }

  ${selectorList(IMAGE_BAND_SELECTORS, '::after')} {
    ${OVERLAY}
    padding-block-start: calc(100% * var(${IMAGE_RATIO}, 0));
    ${BASELINE_LAYERS}
  }


  ${selectorList(SPAN_SELECTORS, '::after')} {
    ${OVERLAY}
    bottom: auto;
    height: var(${SPAN_HEIGHT}, 0);
    ${BASELINE_LAYERS}
  }

  ${selectorList(MARGIN_LINE_REGIONS, '::after')} {
    ${OVERLAY}
    padding-inline: calc(var(--grid-guides-baseline) / 2);
    background-origin: content-box;
    background-repeat: no-repeat;
    background-image: ${marginLinesGradient};
  }

  body::after {
    display: none;
  }

  @media ${DESKTOP} {
    ${SPIRAL_TEMPLATES.map((template) => `body:has(#MainContent[data-template='${template}'])::after`).join(',\n  ')} {
      ${OVERLAY}
      display: block;
      position: fixed;
      top: var(--header-group-height, calc(var(--grid-guides-baseline) * 2));
      right: ${INSET};
      bottom: auto;
      left: ${INSET};
      aspect-ratio: 8 / 5;
      background-repeat: no-repeat;
      background-size: 100% 40%, 100% 100%;
      background-image: ${spiralCutGradient}, url("data:image/svg+xml,${encodeURIComponent(spiralSvg)}");
    }
  }

  ${MIRRORED_SPIRAL_TEMPLATES.map((template) => `body:has(#MainContent[data-template='${template}'])::after`).join(',\n')} {
    transform: scaleX(-1);
  }
  `;

    const STYLE_ID = 'grid-guides-styles';
    let style = document.getElementById(STYLE_ID);

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.append(style);
    }

    style.textContent = STYLES;

    const touch = matchMedia(TOUCH);
    const stored = localStorage.getItem(STYLE_ID);
    let mode = MODES.includes(stored) ? stored : MODES[0];
    let scrolling = false;
    let scrollTimer;

    const modeInEffect = () => (touch.matches ? MODES[0] : mode);

    const show = () => {
      const current = modeInEffect();

      style.disabled = current === 'off' || (current === 'scroll' && !scrolling);
    };

    const setMode = (value) => {
      mode = value;
      show();
      localStorage.setItem(STYLE_ID, mode);
    };

    setMode(mode);

    addEventListener('keydown', (event) => {
      if (touch.matches || !event.ctrlKey || event.metaKey || event.altKey || event.key.toLowerCase() !== 'g') return;

      event.preventDefault();
      setMode(MODES[(MODES.indexOf(mode) + 1) % MODES.length]);
    });

    touch.addEventListener('change', show);

    const setScrolling = (value) => {
      scrolling = value;
      show();
    };

    const scrolled = () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => setScrolling(false), SCROLL_HOLD);

      if (!scrolling) setScrolling(true);
    };

    addEventListener('scroll', scrolled, { capture: true, passive: true });
    addEventListener('wheel', scrolled, { passive: true });

    const BASELINE_EPSILON = 0.1;

    const leading = () =>
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--grid-guides-baseline')) || LEADING;

    const halfUnits = HALF_UNIT_REGIONS.map(([selector, media]) => [selector, media ? matchMedia(media) : null]);

    const isHalfUnit = (region) =>
      halfUnits.some(([selector, query]) => (!query || query.matches) && region.matches(selector));

    const unitFor = (region) => leading() / (isHalfUnit(region) ? 2 : 1);

    const isOnBaseline = (length, unit = leading()) => {
      const remainder = length % unit;
      return remainder < BASELINE_EPSILON || unit - remainder < BASELINE_EPSILON;
    };

    const baselineColor = (length, unit) =>
      isOnBaseline(length, unit) ? 'var(--grid-guides-edge-color)' : 'var(--grid-guides-warning-color)';

    const applies = new WeakMap();
    const tracked = new Set();

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) applies.get(entry.target)?.(entry.target);
    });

    const restoreOnWipe = (element, property, restore) => {
      new MutationObserver(() => {
        if (element.style.getPropertyValue(property)) return;
        restore(element);
      }).observe(element, { attributes: true, attributeFilter: ['style'] });
    };

    const observeFor = (target, apply, box) => {
      if (applies.has(target)) return false;

      applies.set(target, apply);
      tracked.add(target);
      observer.observe(target, box && { box });
      return true;
    };

    const watch = (element, apply, { box, property = TOP_LINE } = {}) => {
      if (observeFor(element, apply, box)) restoreOnWipe(element, property, apply);
    };

    const eachIn = function* (root, selector) {
      if (root.matches?.(selector)) yield root;

      yield* root.querySelectorAll(selector);
    };

    const watchAll = (selectors, apply, options, root = document) => {
      for (const selector of [selectors].flat()) {
        for (const element of eachIn(root, selector)) watch(element, apply, options);
      }
    };

    const checkHeight = (region) =>
      region.style.setProperty(TOP_LINE, baselineColor(region.getBoundingClientRect().height, unitFor(region)));

    const checkPadding = (region) =>
      region.style.setProperty(TOP_LINE, baselineColor(parseFloat(getComputedStyle(region).paddingBlockEnd)));

    const paddingBoxWidth = (element) => {
      const style = getComputedStyle(element);

      return element.getBoundingClientRect().width
        - parseFloat(style.borderInlineStartWidth)
        - parseFloat(style.borderInlineEndWidth);
    };

    const isShown = (element) => element.getClientRects().length > 0;

    const contiguous = (elements) => {
      const run = [];

      for (const element of elements) {
        if (run.length && element.previousElementSibling !== run.at(-1)) break;

        run.push(element);
      }

      return run;
    };

    const measureFrom = (child, geometry) => (element) => {
      const targets = [...element.querySelectorAll(child)];

      if (!targets.length) return;

      const measured = geometry(element, targets);

      if (!measured) return;

      element.style.setProperty(measured.property, measured.value);
      element.style.setProperty(TOP_LINE, baselineColor(measured.check, unitFor(element)));
    };

    const imageBand = (element, images) => {
      const width = paddingBoxWidth(element);
      const box = element.getBoundingClientRect();
      const shown = contiguous(images).filter(isShown);
      const height = Math.max(...shown.map((image) => image.getBoundingClientRect().bottom)) - box.top;

      return width > 0 && shown.length > 0 && height > 0 && {
        property: IMAGE_RATIO,
        value: height / width,
        check: box.height - height,
      };
    };

    const spanToChild = (element, children) => {
      const [child] = children.filter(isShown);

      if (!child) return false;

      const height =
        child.getBoundingClientRect().bottom
        + parseFloat(getComputedStyle(child).marginBlockEnd)
        - element.getBoundingClientRect().top;

      return height > 0 && { property: SPAN_HEIGHT, value: `${height}px`, check: height };
    };

    const MEASURED_REGIONS = [
      ...IMAGE_BAND_REGIONS.map(([region, child]) => [region, child, measureFrom(child, imageBand), IMAGE_RATIO]),
      ...SPAN_REGIONS.map(([region, child]) => [region, child, measureFrom(child, spanToChild), SPAN_HEIGHT]),
    ];

    const watchMeasuredIn = (root) => {
      for (const [region, child, apply, property] of MEASURED_REGIONS) {
        for (const element of eachIn(root, region)) {
          watch(element, apply, { property });

          for (const target of element.querySelectorAll(child)) observeFor(target, () => apply(element));
        }
      }
    };

    watchAll(BASELINE_REGIONS, checkHeight, { box: 'border-box' });
    watchAll(PADDING_BASELINE_REGIONS, checkPadding, { box: 'border-box' });
    watchMeasuredIn(document);

    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) watchMeasuredIn(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    const LEADING_PROBE_ID = 'grid-guides-leading-probe';
    let leadingProbe = document.getElementById(LEADING_PROBE_ID);

    if (!leadingProbe) {
      leadingProbe = document.createElement('div');
      leadingProbe.id = LEADING_PROBE_ID;
      leadingProbe.style.cssText = 'position: fixed; width: 0; height: var(--grid-guides-baseline); visibility: hidden; pointer-events: none;';
      document.body.append(leadingProbe);
    }

    const replay = () => {
      for (const element of tracked) applies.get(element)?.(element);
    };

    new ResizeObserver(replay).observe(leadingProbe, { box: 'border-box' });

    for (const [, query] of halfUnits) query?.addEventListener('change', replay);
  })();
  } catch(e) { console.error(e); }
})();

})();
